import {
    STOCK_MASSIVE_UPLOAD_DOWNLOAD_TEMPLATE_BEGIN,
    STOCK_MASSIVE_UPLOAD_DOWNLOAD_TEMPLATE_SUCCESS,
    STOCK_MASSIVE_UPLOAD_DOWNLOAD_TEMPLATE_FAILURE,
    STOCK_MASSIVE_UPLOAD_DOWNLOAD_TEMPLATE_DISMISS_ERROR,
} from './constants';

import { BFFAgent } from '../../../common/BFFAgent';
import * as FileSaver from 'file-saver';
import { XML_TYPE } from 'Utilities';

export function downloadStockTemplate() {

    return (dispatch, getState) => { // optionally you can have getState as the second argument
        dispatch({
            type: STOCK_MASSIVE_UPLOAD_DOWNLOAD_TEMPLATE_BEGIN,
        });
        BFFAgent.Stock.downloadStockTemplate().then(
            (fileBuffer) => {
                // Genero una URL temporal
                const file = new Blob(
                    [fileBuffer],
                    {
                        // Mime type de excel
                        type: XML_TYPE,
                    }
                )
                // Descargo el archivo
                FileSaver.saveAs(file, 'CargaMasivaPlantilla.xlsx')
                dispatch({
                    type: STOCK_MASSIVE_UPLOAD_DOWNLOAD_TEMPLATE_SUCCESS,
                });
            },
            // Use rejectHandler as the second argument so that render errors won't be caught.
            (err) => {
                dispatch({
                    type: STOCK_MASSIVE_UPLOAD_DOWNLOAD_TEMPLATE_FAILURE,
                    data: { error: err },
                });
            },
        );
    };
}
export function dismissUploadCargaMasiva() {
    return {
        type: STOCK_MASSIVE_UPLOAD_DOWNLOAD_TEMPLATE_DISMISS_ERROR,
    };
}

export function reducer(state, action) {
    switch (action.type) {
        case STOCK_MASSIVE_UPLOAD_DOWNLOAD_TEMPLATE_BEGIN:
            // Just after a request is sent
            return {
                ...state,
                downloadStockTemplatePending: true,
                downloadStockTemplateError: null,
            };

        case STOCK_MASSIVE_UPLOAD_DOWNLOAD_TEMPLATE_SUCCESS:
            // The request is success
            return {
                ...state,
                downloadStockTemplatePending: false,
                downloadStockTemplateError: null,
            };

        case STOCK_MASSIVE_UPLOAD_DOWNLOAD_TEMPLATE_FAILURE:
            // The request is failed
            return {
                ...state,
                downloadStockTemplatePending: false,
                downloadStockTemplateError: action.data.error,
            };

        case STOCK_MASSIVE_UPLOAD_DOWNLOAD_TEMPLATE_DISMISS_ERROR:
            // Dismiss the request failure error
            return {
                ...state,
                downloadStockTemplateError: null,
            };

        default:
            return state;
    }
}